import { prependAppName } from "shared/imports/sharedHelperFunctions"
const appName = "@@sheets/"

// eslint-disable-next-line no-underscore-dangle
const _actionTypes = {
    // getting the available custom fields
    GET_SHEETS_CUSTOM_FIELDS_START: "GET_SHEETS_CUSTOM_FIELDS_START",
    GET_SHEETS_CUSTOM_FIELDS_SUCCESS: "GET_SHEETS_CUSTOM_FIELDS_SUCCESS",
    GET_SHEETS_CUSTOM_FIELDS_FAIL: "GET_SHEETS_CUSTOM_FIELDS_FAIL",

    // fetching spreadsheets
    GET_SHEET_START: "GET_SHEET_START",
    GET_SHEET_SUCCESS: "GET_SHEET_SUCCESS",
    GET_SHEET_FAIL: "GET_SHEET_FAIL",

    // scrolling through the table
    SCROLL_TABLE: "SCROLL_TABLE",

    // clicking on cells
    CLICK_CELL: "CLICK_CELL",

    // fetching multiple columns
    GET_COLUMNS_START: "GET_COLUMNS_START",
    GET_COLUMNS_SUCCESS: "GET_COLUMNS_SUCCESS",
    GET_COLUMNS_FAIL: "GET_COLUMN_FAIL",

    // fetching single columns
    GET_COLUMN_START: "GET_COLUMN_START",
    GET_COLUMN_SUCCESS: "GET_COLUMN_SUCCESS",
    GET_COLUMN_FAIL: "GET_COLUMN_FAIL",

    // updating columns
    RESIZE_COLUMN: "RESIZE_COLUMN",
    RENAME_COLUMN: "RENAME_COLUMN",
    REORDER_COLUMN: "REORDER_COLUMN",
    TOGGLE_COLUMN_IS_HIDDEN_ON_PUBLIC: "TOGGLE_COLUMN_IS_HIDDEN_ON_PUBLIC",
    TOGGLE_COLUMN_DEFAULT_SORTING: "TOGGLE_COLUMN_DEFAULT_SORTING",
    TOGGLE_DATUM_COLUMN_IS_HIDDEN_ON_PUBLIC: "TOGGLE_DATUM_COLUMN_IS_HIDDEN_ON_PUBLIC",

    SAVE_COLUMN_ORDER_START: "SAVE_COLUMN_ORDER",
    SAVE_COLUMN_ORDER_SUCCESS: "SAVE_COLUMN_ORDER_SUCCESS",
    SAVE_COLUMN_ORDER_FAIL: "SAVE_COLUMN_ORDER_FAIL",

    PATCH_COLUMN_START: "PATCH_COLUMN_START",
    PATCH_COLUMN_SUCCESS: "PATCH_COLUMN_SUCCESS",
    PATCH_COLUMN_FAIL: "PATCH_COLUMN_FAIL",

    PATCH_COLUMNS_START: "PATCH_COLUMNS_START",
    PATCH_COLUMNS_SUCCESS: "PATCH_COLUMNS_SUCCESS",
    PATCH_COLUMNS_FAIL: "PATCH_COLUMNS_FAIL",

    // searching rows
    ROW_SEARCH_OPEN: "ROW_SEARCH_OPEN",
    ROW_SEARCH_CLOSE: "ROW_SEARCH_CLOSE",
    UPDATE_ROW_SEARCH_TERM: "UPDATE_ROW_SEARCH_TERM",

    // focusing on columns
    FOCUS_COLUMN: "FOCUS_COLUMN",
    UNFOCUS_COLUMN: "UNFOCUS_COLUMN",

    // sorting columns
    SORT_BY_COLUMN: "SORT_BY_COLUMN",

    EDIT_COLUMN: "EDIT_COLUMN",
    EDIT_SCORECARD_ITEM: "EDIT_SCORECARD_ITEM",
    ADD_SCORECARD_ITEM: "ADD_SCORECARD_ITEM",
    REMOVE_SCORECARD_ITEM: "REMOVE_SCORECARD_ITEM",
    // SEARCHIFY_SCORECARD_ITEM: "SEARCHIFY_SCORECARD_ITEM",

    SHEET_CLEAR_FILTER_AND_SORT: "SHEET_CLEAR_FILTER_AND_SORT",

    // only clear filters
    SHEET_CLEAR_FILTER: "SHEET_CLEAR_FILTER",

    // only clear sorting
    SHEET_CLEAR_SORT: "SHEET_CLEAR_SORT",

    // Stuff for sheet form
    CREATE_BLANK_SHEET: "CREATE_BLANK_SHEET",
    EDIT_SHEET: "EDIT_SHEET",
    SHEET_COMPLETE_SEARCHIFY: "SHEET_COMPLETE_SEARCHIFY",

    INIT_SHEET_FORM: "INIT_SHEET_FORM",

    REMOVE_SHEET_FORM_ROW_FILTER: "REMOVE_SHEET_FORM_ROW_FILTER",

    POST_SHEET_START: "POST_SHEET_START",
    POST_SHEET_SUCCESS: "POST_SHEET_SUCCESS",
    POST_SHEET_FAIL: "POST_SHEET_FAIL",

    PATCH_SHEET_START: "PATCH_SHEET_START",
    PATCH_SHEET_SUCCESS: "PATCH_SHEET_SUCCESS",
    PATCH_SHEET_FAIL: "PATCH_SHEET_FAIL",

    RESOURCE_TABLE_REMOVE_ROW: "RESOURCE_TABLE_REMOVE_ROW",
    RESOURCE_TABLE_RESTORE_ROW: "RESOURCE_TABLE_RESTORE_ROW",

    RESOURCE_TABLE_CLEAR_ALL_ROWS: "RESOURCE_TABLE_CLEAR_ALL_ROWS",

    SHEET_REMOVE_ROW: "SHEET_REMOVE_ROW",
    SHEET_REMOVE_COLUMN: "SHEET_REMOVE_COLUMN",
    SHEET_UPDATE_ADDED_IDS: "SHEET_UPDATE_ADDED_IDS",
    SHEET_UPDATE_DELETED_IDS: "SHEET_DELETED_ADDED_IDS",

    GET_RESOURCE_TABLE_DATA_START: "GET_RESOURCE_TABLE_DATA_START",
    GET_RESOURCE_TABLE_DATA_SUCCESS: "GET_RESOURCE_TABLE_DATA_SUCCESS",
    GET_RESOURCE_TABLE_DATA_FAIL: "GET_RESOURCE_TABLE_DATA_FAIL",

    GET_RESOURCE_TABLE_INTERVAL_START: "GET_RESOURCE_TABLE_INTERVAL_START",
    GET_RESOURCE_TABLE_INTERVAL_SUCCESS: "GET_RESOURCE_TABLE_INTERVAL_SUCCESS",
    GET_RESOURCE_TABLE_INTERVAL_FAIL: "GET_RESOURCE_TABLE_INTERVAL_FAIL",

    GET_BIG_SHEET_START: "GET_BIG_SHEET_START",
    GET_BIG_SHEET_SUCCESS: "GET_BIG_SHEET_SUCCESS",
    GET_BIG_SHEET_FAIL: "GET_BIG_SHEET_FAIL",

    GET_BIG_SHEET_INTERVAL_START: "GET_BIG_SHEET_INTERVAL_START",
    GET_BIG_SHEET_INTERVAL_SUCCESS: "GET_BIG_SHEET_INTERVAL_SUCCESS",
    GET_BIG_SHEET_INTERVAL_FAIL: "GET_BIG_SHEET_INTERVAL_FAIL",

    TOGGLE_PUBLIC_SHEET: "TOGGLE_PUBLIC_SHEET",

    TOGGLE_PUBLIC_SHEET_PASSWORD_REQUIRED: "TOGGLE_PUBLIC_SHEET_PASSWORD_REQUIRED",

    TOGGLE_SHOW_MAP: "TOGGLE_SHOW_MAP",

    SHEET_INIT: "SHEET_INIT",
    SEARCH_BY_COLUMN: "SEARCH_BY_COLUMN",
    SEARCH_BY_DATE_RANGE_COLUMN: "SEARCH_BY_COLUMN",

    ADD_MAP_FILTER: "ADD_MAP_FILTER",
    REMOVE_MAP_FILTER: "REMOVE_MAP_FILTER",

    // column form
    INIT_COLUMN_FORM: "INIT_COLUMN_FORM",
    COLUMN_FORM_COMPLETE_SEARCHIFY: "COLUMN_FORM_COMPLETE_SEARCHIFY",
    EDIT_COLUMN_FORM: "EDIT_COLUMN_FORM",

    POST_COLUMN_START: "POST_COLUMN_START",
    POST_COLUMN_SUCCESS: "POST_COLUMN_SUCCESS",
    POST_COLUMN_FAIL: "POST_COLUMN_FAIL",

    TOGGLE_SELECT_OPEN: "TOGGLE_SELECT_OPEN",

    TOGGLE_COLUMN_SUBMITTING: "TOGGLE_COLUMN_SUBMITTING",

    TOGGLE_SHEET_SUBMITTING: "TOGGLE_SHEET_SUBMITTING",

    TOGGLE_DOWNLOADING_CSV: "TOGGLE_DOWNLOADING_CSV",

    // visualizations
    MERGE_VIS_DICT: "MERGE_VIS_DICT",

    DUPLICATE_SHEET_START: "DUPLICATE_SHEET_START",
    DUPLICATE_SHEET_SUCCESS: "DUPLICATE_SHEET_SUCCESS",
    DUPLICATE_SHEET_FAIL: "DUPLICATE_SHEET_FAIL",

    DOWNLOAD_SHEET_CSV_START: "DOWNLOAD_SHEET_CSV_START",
    DOWNLOAD_SHEET_CSV_SUCCESS: "DOWNLOAD_SHEET_CSV_SUCCESS",
    DOWNLOAD_SHEET_CSV_FAIL: "DOWNLOAD_SHEET_CSV_FAIL",

    START_SHEET_SEARCHIFY: "START_SHEET_SEARCHIFY",
    SHEET_FORM_SUBMIT_SEARCHIFY: "SHEET_FORM_SUBMIT_SEARCHIFY",
    SHEET_COLUMN_SUBMIT_SEARCHIFY: "SHEET_COLUMN_SUBMIT_SEARCHIFY",
    SHEET_CUSTOM_DATA_COLUMN_SUBMIT_SEARCHIFY: "SHEET_CUSTOM_DATA_COLUMN_SUBMIT_SEARCHIFY",

    // patching a resource from a resource table
    PATCH_RESOURCE_TABLE_RESOURCE_START: "PATCH_RESOURCE_TABLE_RESOURCE_START",
    PATCH_RESOURCE_TABLE_RESOURCE_SUCCESS: "PATCH_RESOURCE_TABLE_RESOURCE_SUCCESS",
    PATCH_RESOURCE_TABLE_RESOURCE_FAIL: "PATCH_RESOURCE_TABLE_RESOURCE_FAIL",

    STORE_RESOURCE_TABLE_CONFIGURATION: "STORE_RESOURCE_TABLE_CONFIGURATION",

    RESOURCE_TABLE_UPDATE_ROW: "RESOURCE_TABLE_UPDATE_ROW",

    // updating a single cell's state (also implicitly changed in resource table start and successes)
    UPDATE_CELL_STATE: "UPDATE_CELL_STATE",
    RESET_CELL_STATE: "RESET_CELL_STATE",
    UPDATE_RESOURCE_TABLE_CELL_STATE: "UPDATE_RESOURCE_TABLE_CELL_STATE",

    RESOURCE_TABLE_REORDER: "RESOURCE_TABLE_REORDER",
    RESOURCE_TABLE_UPDATE: "RESOURCE_TABLE_UPDATE",
    SET_WINDOW_SIZE: "SET_WINDOW_SIZE",
    PATCH_COLUMN_OBJECT_SUCCESS: "PATCH_COLUMN_OBJECT_SUCCESS",

    LOAD_COLUMN_FOR_CUSTOM_COLOR_FORM_START: "LOAD_COLUMN_FOR_CUSTOM_COLOR_FORM_START",
    LOAD_COLUMN_FOR_CUSTOM_COLOR_FORM_SUCCESS: "LOAD_COLUMN_FOR_CUSTOM_COLOR_FORM_SUCCESS",
    LOAD_COLUMN_FOR_CUSTOM_COLOR_FORM_FAIL: "LOAD_COLUMN_FOR_CUSTOM_COLOR_FORM_FAIL",

    PATCH_COLUMN_FOR_CUSTOM_COLOR_FORM_START: "PATCH_COLUMN_FOR_CUSTOM_COLOR_FORM_START",
    PATCH_COLUMN_FOR_CUSTOM_COLOR_FORM_SUCCESS: "PATCH_COLUMN_FOR_CUSTOM_COLOR_FORM_SUCCESS",
    PATCH_COLUMN_FOR_CUSTOM_COLOR_FORM_FAIL: "PATCH_COLUMN_FOR_CUSTOM_COLOR_FORM_FAIL",

    PERSONAL_PIN_SHEET_FOR_USER_START: "PERSONAL_PIN_SHEET_FOR_USER_START",
    PERSONAL_PIN_SHEET_FOR_USER_SUCCESS: "PERSONAL_PIN_SHEET_FOR_USER_SUCCESS",
    PERSONAL_PIN_SHEET_FOR_USER_FAIL: "PERSONAL_PIN_SHEET_FOR_USER_FAIL",

    UPDATE_COLUMN_FOR_CUSTOM_COLOR_FORM: "UPDATE_COLUMN_FOR_CUSTOM_COLOR_FORM",

    SET_SHOULD_SHOW_STATS_BAR: "SET_SHOULD_SHOW_STATS_BAR",

    PATCH_SHOULD_SHOW_MATH_SHEET_START: "PATCH_SHOULD_SHOW_MATH_SHEET_START",
    PATCH_SHOULD_SHOW_MATH_SHEET_SUCCESS: "PATCH_SHOULD_SHOW_MATH_SHEET_SUCCESS",
    PATCH_SHOULD_SHOW_MATH_SHEET_FAIL: "PATCH_SHOULD_SHOW_MATH_SHEET_FAIL",
}

const actionTypes = prependAppName(appName, _actionTypes)

export default actionTypes

export const getColumns = {
    start: actionTypes.GET_COLUMNS_START,
    success: actionTypes.GET_COLUMNS_SUCCESS,
    fail: actionTypes.GET_COLUMNS_FAIL,
}

export const getCustomFields = {
    start: actionTypes.GET_SHEETS_CUSTOM_FIELDS_START,
    success: actionTypes.GET_SHEETS_CUSTOM_FIELDS_SUCCESS,
    fail: actionTypes.GET_SHEETS_CUSTOM_FIELDS_FAIL,
}

export const getSheet = {
    start: actionTypes.GET_SHEET_START,
    success: actionTypes.GET_SHEET_SUCCESS,
    fail: actionTypes.GET_SHEET_FAIL,
}

export const patchColumnData = {
    start: actionTypes.PATCH_COLUMN_START,
    success: actionTypes.PATCH_COLUMN_SUCCESS,
    fail: actionTypes.PATCH_COLUMN_FAIL,
}

export const patchColumn = {
    start: actionTypes.PATCH_COLUMN_START,
    success: actionTypes.PATCH_COLUMN_OBJECT_SUCCESS,
    fail: actionTypes.PATCH_COLUMN_FAIL,
}

export const saveColumnOrder = {
    start: actionTypes.SAVE_COLUMN_ORDER_START,
    success: actionTypes.SAVE_COLUMN_ORDER_SUCCESS,
    fail: actionTypes.SAVE_COLUMN_ORDER_FAIL,
}

export const patchColumns = {
    start: actionTypes.PATCH_COLUMNS_START,
    success: actionTypes.PATCH_COLUMNS_SUCCESS,
    fail: actionTypes.PATCH_COLUMNS_FAIL,
}

export const postSheet = {
    start: actionTypes.POST_SHEET_START,
    success: actionTypes.POST_SHEET_SUCCESS,
    fail: actionTypes.POST_SHEET_FAIL,
}

export const patchResourceTableResource = {
    start: actionTypes.PATCH_RESOURCE_TABLE_RESOURCE_START,
    success: actionTypes.PATCH_RESOURCE_TABLE_RESOURCE_SUCCESS,
    fail: actionTypes.PATCH_RESOURCE_TABLE_RESOURCE_FAIL,
}

export const patchSheet = {
    start: actionTypes.PATCH_SHEET_START,
    success: actionTypes.PATCH_SHEET_SUCCESS,
    fail: actionTypes.PATCH_SHEET_FAIL,
}

export const getResourceTable = {
    start: actionTypes.GET_RESOURCE_TABLE_DATA_START,
    success: actionTypes.GET_RESOURCE_TABLE_DATA_SUCCESS,
    fail: actionTypes.GET_RESOURCE_TABLE_DATA_FAIL,
}

export const getResourceTableInterval = {
    start: actionTypes.GET_RESOURCE_TABLE_INTERVAL_START,
    success: actionTypes.GET_RESOURCE_TABLE_INTERVAL_SUCCESS,
    fail: actionTypes.GET_RESOURCE_TABLE_INTERVAL_FAIL,
}

export const getBigSheet = {
    start: actionTypes.GET_BIG_SHEET_START,
    success: actionTypes.GET_BIG_SHEET_SUCCESS,
    fail: actionTypes.GET_BIG_SHEET_FAIL,
}

export const getBigSheetInterval = {
    start: actionTypes.GET_BIG_SHEET_INTERVAL_START,
    success: actionTypes.GET_BIG_SHEET_INTERVAL_SUCCESS,
    fail: actionTypes.GET_BIG_SHEET_INTERVAL_FAIL,
}

export const postColumn = {
    start: actionTypes.POST_COLUMN_START,
    success: actionTypes.POST_COLUMN_SUCCESS,
    fail: actionTypes.POST_COLUMN_FAIL,
}

export const duplicateSheet = {
    start: actionTypes.DUPLICATE_SHEET_START,
    success: actionTypes.DUPLICATE_SHEET_SUCCESS,
    fail: actionTypes.DUPLICATE_SHEET_FAIL,
}

export const downloadSheetCSV = {
    start: actionTypes.DOWNLOAD_SHEET_CSV_START,
    success: actionTypes.DOWNLOAD_SHEET_CSV_SUCCESS,
    fail: actionTypes.DOWNLOAD_SHEET_CSV_FAIL,
}

export const loadColumnForCustomColorForm = {
    start: actionTypes.LOAD_COLUMN_FOR_CUSTOM_COLOR_FORM_START,
    success: actionTypes.LOAD_COLUMN_FOR_CUSTOM_COLOR_FORM_SUCCESS,
    fail: actionTypes.LOAD_COLUMN_FOR_CUSTOM_COLOR_FORM_FAIL,
}

export const patchColumnForCustomColorForm = {
    start: actionTypes.PATCH_COLUMN_FOR_CUSTOM_COLOR_FORM_START,
    success: actionTypes.PATCH_COLUMN_FOR_CUSTOM_COLOR_FORM_SUCCESS,
    fail: actionTypes.PATCH_COLUMN_FOR_CUSTOM_COLOR_FORM_FAIL,
}

export const patchShouldShowSheetMathBar = {
    start: actionTypes.PATCH_SHOULD_SHOW_MATH_SHEET_START,
    success: actionTypes.PATCH_SHOULD_SHOW_MATH_SHEET_SUCCESS,
    fail: actionTypes.PATCH_SHOULD_SHOW_MATH_SHEET_FAIL,
}

export const personallyPinSheetForUser = {
    start: actionTypes.PERSONAL_PIN_SHEET_FOR_USER_START,
    success: actionTypes.PERSONAL_PIN_SHEET_FOR_USER_SUCCESS,
    fail: actionTypes.PERSONAL_PIN_SHEET_FOR_USER_FAIL,
}
